import { render, staticRenderFns } from "./malody2phigros.vue?vue&type=template&id=1303cc8a&"
import script from "./malody2phigros.vue?vue&type=script&lang=ts&"
export * from "./malody2phigros.vue?vue&type=script&lang=ts&"
import style0 from "./malody2phigros.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports